import { useWs } from "@/Core/net/socket/SocketHooks"
import { useForcedLogout } from "@/features/auth/useForcedLogout";
import { useEffect } from "react";
import { useBeforeSetting } from "./beforeSetting";
import { Lobby } from "@/proto/Lobby";


/**监听更新大厅余额 */
export const useWsUpdateBanblce = (getCache = true) => {
    const { data } = useWs<Lobby.Lobby.IBalanceChangeNotifyMc>(
        Lobby.LobbyPacketID.PACKET_MC_BALANCE_CHANGE,
        Lobby.Lobby.BalanceChangeNotifyMc,
        getCache);
    return {
        data
    }
}
/**监听邮件刷新 */
export const useWsUpdateEmail = () => {
    const { data } = useWs<Lobby.Lobby.INewEmailMc>(
        Lobby.LobbyPacketID.PACKET_MC_NEW_EMAIL,
        Lobby.Lobby.NewEmailMc
    );
    return {
        data
    }
}

/**监听服务端强制退出登录 */
export const useWsLoginOut = () => {
    const { data } = useWs<Lobby.Lobby.ILoginOutMc>(
        Lobby.LobbyPacketID.PACKET_MC_LOGINOUT,
        Lobby.Lobby.LoginOutMc);
    const forceLogout = useForcedLogout();
    useEffect(() => {
        if (data !== undefined) {
            forceLogout();
        }
    }, [data, forceLogout])
    return {
        data
    }
}

/**监听奖励刷新 */
export const useWsUpdateBouns = () => {
    const { data } = useWs<Lobby.Lobby.ITaskFinishMc>(
        Lobby.LobbyPacketID.PACKET_MC_TASK_FINISH,
        Lobby.Lobby.TaskFinishMc);
    return {
        data
    }
}

/**监听刷新配置 */
export const useWsRefreshSettings = () => {
    const { data } = useWs<Lobby.Lobby.IConfigChangeMc>(
        Lobby.LobbyPacketID.PACKET_MC_CONFIG_CHANGE,
        Lobby.Lobby.ConfigChangeMc);
    const { mutate } = useBeforeSetting(false)
    useEffect(() => {
        if (data) {
            try {
                const settingData = JSON.parse(data.message);
                mutate(settingData, { revalidate: false })
            } catch (e) {
                console.error(e);
            }
        }
    }, [data])
    return {
        data
    }
}

/**监听其它错误 */
export const useWsError = () => {
    useWs<Lobby.Lobby.IReplyRs>(
        Lobby.LobbyPacketID.PACKET_RS_REPLY,
        Lobby.Lobby.ReplyRs
    )
}

/**监听钱包弹窗 */
export const useWsOpenWallet = () => {
    const { data } = useWs<Lobby.Lobby.IInsufficientBalanceMc>(
        Lobby.LobbyPacketID.PACKET_MC_INSUFFICIENT_BALANCE,
        Lobby.Lobby.InsufficientBalanceMc
    )
    return { data };
}
